import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import hi from "../locales/hi.json";
import ml from "../locales/ml.json";
import mr from "../locales/mr.json";
import ar from "../locales/ar.json";
import bn from "../locales/bn.json";
import de from "../locales/de.json";
import es from "../locales/es.json";
import fr from "../locales/fr.json";
import it from "../locales/it.json";
import jp from "../locales/jp.json";
import kn from "../locales/kn.json";
import ko from "../locales/ko.json";
import nl from "../locales/nl.json";
import pt from "../locales/pt.json";
import ru from "../locales/ru.json";
import ta from "../locales/ta.json";
import te from "../locales/te.json";
import tr from "../locales/tr.json";
import zh from "../locales/zh.json";

interface User {
  language_code: string;
}

interface Handle {
  user: User;
}

const rawHandle = localStorage.getItem("handle");
const handle: Handle | null = rawHandle ? JSON.parse(rawHandle) : null;
const user = handle?.user;
const selectedLoc: string = user ? user.language_code : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    ml: { translation: ml },
    mr: { translation: mr },
    ar: { translation: ar },
    bn: { translation: bn },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
    it: { translation: it },
    ja: { translation: jp },
    kn: { translation: kn },
    ko: { translation: ko },
    nl: { translation: nl },
    pt: { translation: pt },
    ru: { translation: ru },
    ta: { translation: ta },
    te: { translation: te },
    tr: { translation: tr },
    zh: { translation: zh },
  },
  lng: selectedLoc,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;